import { render, staticRenderFns } from "./DepartmentListView.vue?vue&type=template&id=31d10736&scoped=true"
import script from "./DepartmentListView.vue?vue&type=script&lang=js"
export * from "./DepartmentListView.vue?vue&type=script&lang=js"
import style0 from "./DepartmentListView.vue?vue&type=style&index=0&id=31d10736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d10736",
  null
  
)

export default component.exports